import { useEffect, useRef } from "react";
import { useNavigationType } from "react-router-dom";

const savedPositions = new Map();

export default function ScrollToTop({ pathname }) {
  const navigationType = useNavigationType();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !pathname) return undefined;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    let frame = 0;
    const onScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        savedPositions.set(pathname, window.scrollY);
        if (savedPositions.size > 60) {
          savedPositions.delete(savedPositions.keys().next().value);
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(frame);
    };
  }, [pathname]);

  useEffect(() => {
    if (typeof window === "undefined" || !pathname) return;
    if (lastPathRef.current === pathname) return;
    const isPop = navigationType === "POP";
    lastPathRef.current = pathname;

    if (isPop) {
      const target = savedPositions.get(pathname);
      if (Number.isFinite(target) && target > 120) {
        let attempts = 0;
        const tryRestore = () => {
          attempts += 1;
          const max = document.documentElement.scrollHeight - window.innerHeight;
          if (max >= target) {
            window.scrollTo(0, target);
            return;
          }
          if (attempts >= 8) {
            window.scrollTo(0, Math.max(max, 0));
            return;
          }
          setTimeout(tryRestore, 150);
        };
        requestAnimationFrame(tryRestore);
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
